query TravelerFirstFlight( 
    $travelAuthorizationId: UUID!
    $travelerId: UUID!) {
  travelerFirstFlight( travelerId: $travelerId
  travelAuthorizationId: $travelAuthorizationId
  ) {
   _carrierId
    _depotId
    _depotDescription
  }
}
